<template>
  <header>
    <h1 class="sr-only">Tips calculator app</h1>
    <img src="/images/logo.svg" alt="website logo" />
  </header>
</template>

<style lang="scss" scoped>
header {
  display: flex;
  justify-content: center;
  padding: 3.125rem 0;
}
</style>
